import { render, staticRenderFns } from "./stunoplan.vue?vue&type=template&id=b01ad4e6&scoped=true"
import script from "./stunoplan.vue?vue&type=script&lang=js"
export * from "./stunoplan.vue?vue&type=script&lang=js"
import style0 from "./stunoplan.vue?vue&type=style&index=0&id=b01ad4e6&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01ad4e6",
  null
  
)

export default component.exports